import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../../material/material.module';
import { ForceApprovePopupComponent } from './force-approve-popup.component';

@NgModule({
  declarations: [ForceApprovePopupComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule],
  exports: [ForceApprovePopupComponent],
})
export class ForceApprovePopupModule {}
